import React from 'react'

export default class IconsMainNavSms extends React.Component {
    render() {
        let className = 'icons-icon'

        return (
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                className={className}
                style={this.props.style}
            >
                <path
                    d='M11.3333 1.33331H4.66668C3.9303 1.33331 3.33334 1.93027 3.33334 2.66665V13.3333C3.33334 14.0697 3.9303 14.6666 4.66668 14.6666H11.3333C12.0697 14.6666 12.6667 14.0697 12.6667 13.3333V2.66665C12.6667 1.93027 12.0697 1.33331 11.3333 1.33331Z'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M8 12H8.00667'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
